import { ArrowRight, ArrowDown } from "lucide-react";

export const Hero = () => {
  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative min-h-screen flex flex-col justify-center bg-white overflow-hidden pt-20"
    >
      {/* Subtle background accent */}
      <div className="absolute top-0 right-0 w-[50vw] h-full bg-[#F8FAFC] hidden lg:block" />

      <div className="relative z-10 max-w-[1400px] mx-auto px-6 md:px-12 lg:px-20 w-full pt-12 pb-20 md:pt-8 md:pb-0">
        {/* Eyebrow */}
        <div className="anim-fade-up mb-6 md:mb-8">
          <span className="text-[13px] font-semibold tracking-[0.15em] uppercase text-[#0064E0]">
            Focus on what matters most
          </span>
        </div>

        {/* Headline, editorial scale */}
        <h1
          data-testid="hero-headline"
          className="font-['Playfair_Display'] font-semibold text-[#0F172A] tracking-[-0.03em] leading-[0.95] anim-fade-up delay-1"
        >
          <span className="block text-[clamp(44px,6.5vw,100px)]">Paid ads and funnels</span>
          <span className="block text-[clamp(44px,6.5vw,100px)]"><span className="text-highlight">that bring in customers,</span></span>
          <span className="block text-[clamp(44px,6.5vw,100px)]">not just clicks.</span>
        </h1>

        {/* Subheadline, offset right for editorial asymmetry */}
        <div className="mt-10 md:mt-14 max-w-[540px] anim-fade-up delay-3">
          <p
            data-testid="hero-subheadline"
            className="text-[17px] md:text-[19px] lg:text-[20px] leading-[1.65] text-[#475569]"
          >
            Most ad budgets get burned on clicks that never become
            customers. We build data-backed systems and run your paid
            media through conversion optimized funnels to maximize every
            dollar you spend.
          </p>
        </div>

        {/* CTAs */}
        <div className="mt-10 md:mt-14 flex flex-col sm:flex-row gap-4 anim-fade-up delay-5">
          <a
            href=""
            onClick={(e) => { e.preventDefault(); window.Calendly?.initPopupWidget({url: 'https://calendly.com/bldventuresgroup-marketing/30min'}); }}
            data-testid="hero-cta-button"
            className="calendly-cta btn-primary inline-flex items-center justify-center gap-3 bg-[#0064E0] text-white rounded-xl px-10 py-[18px] text-[16px] font-medium hover:bg-[#0052CC] focus:outline-none focus:ring-2 focus:ring-[#0064E0] focus:ring-offset-2 sm:w-auto w-full"
          >
            Book a Discovery Call
            <ArrowRight className="arrow-icon w-[18px] h-[18px]" />
          </a>
          <a
            href="#process"
            onClick={(e) => {
              e.preventDefault();
              document.querySelector("#process")?.scrollIntoView({ behavior: "smooth" });
            }}
            data-testid="hero-secondary-cta"
            className="btn-outline inline-flex items-center justify-center gap-2 bg-transparent text-[#0F172A] border-2 border-[#E2E8F0] rounded-xl px-10 py-[18px] text-[16px] font-medium focus:outline-none focus:ring-2 focus:ring-[#0F172A] focus:ring-offset-2 sm:w-auto w-full"
          >
            See how we work
            <ArrowDown className="w-[18px] h-[18px]" />
          </a>
        </div>
      </div>
    </section>
  );
};